import {ICargoGroupMySuffix} from 'src/app/shared/model//cargo-group-my-suffix.model';
import {ICountryMySuffix} from 'src/app/shared/model//country-my-suffix.model';
import {DeductableType,IRuleDeductableRateMySuffix,RuleDeductableRateMySuffix} from 'src/app/shared/model//rule-deductable-rate-my-suffix.model';
import {IRuleExtensionRateMySuffix,RuleExtensionRateMySuffix} from 'src/app/shared/model//rule-extension-rate-my-suffix.model';
import {ILoadingSubTypeDto} from 'src/app/shared/model/loading-subtype.model';
import {ILoadingTypeMySuffix,LoadingTypeMySuffix} from 'src/app/shared/model/loading-type-my-suffix.model';
import {IPackingTypeMySuffix} from 'src/app/shared/model/packing-type-my-suffix.model';
import {IScopeMySuffix} from 'src/app/shared/model/scope-my-suffix.model';

export const enum MeansOfConveyance {
    VESSEL = 'VESSEL',
    AIR = 'AIR',
    ROAD = 'ROAD',
    RAIL = 'RAIL'
}

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export const enum RuleType {
    LOCAL = 'LOCAL',
    INTERNATIONAL = 'INTERNATIONAL'
}

export const enum PolicyMarketType{
    OPEN ='OPEN',
    GENERIC = 'GENERIC',
    SPOT ='SPOT'

}
export interface IRuleMySuffix {
    id?: number;
    inceptionDate?: Date;
    expiryDate?: Date;
    strInceptionDate?: string;
    strExpiryDate?: string;
    meansOfConveyance?: MeansOfConveyance;
    premiumRate?: number;
    warStrikePremiumRate?: number;
    preShipmentPremiumRate?: number;
    postShipmentPremiumRate?: number;
    activeStatus?: ActiveStatus;
    extensions?: IRuleExtensionRateMySuffix[];
    deductableRates?: IRuleDeductableRateMySuffix[];
    cargoLists?: ICargoGroupMySuffix[];
    fromCountryLists?: ICountryMySuffix[];
    fromCountryListsId?: number[];
    toCountryLists?: ICountryMySuffix[];
    toCountryListsId?: number[];
    scopeRule?: IScopeMySuffix;
    loadingType?: ILoadingTypeMySuffix[];
    loadingTypeList?: any;
    packingTypes?: IPackingTypeMySuffix[];
    loadingSubTypes?: ILoadingSubTypeDto[];
    lastModifiedBy?: string;
    createdByUserRole?: string;
    lastModifiedByUserRole?: string;
    fromEffectiveDate?: string;
    inceptionDateObj?: {};
    expiryDateObj?: {};
    referFormRule?: number;
    markAsRenew?: boolean;
    scopeDeductableType?: DeductableType;
    type?: RuleType;
    policyMarketType ?:PolicyMarketType;
    isRuleUsedInCertificate?:boolean;
    lastModifiedDate?: string;
    subRuleId?: any[];
    ruleIdForOts?:number;
    lineOfBusiness?: string;
    isPreSubRuleIncluded?: boolean;
    isPostSubRuleIncluded?: boolean;
}

export class RuleMySuffix implements IRuleMySuffix {
    constructor(
        public id?: number,
        public inceptionDate?: Date,
        public expiryDate?: Date,
        public strInceptionDate?: string,
        public strExpiryDate?: string,
        public meansOfConveyance?: MeansOfConveyance,
        public premiumRate?: number,
        public warStrikePremiumRate?: number,
        public preShipmentPremiumRate?: number,
        public postShipmentPremiumRate?: number,
        public activeStatus?: ActiveStatus,
        public extensions: IRuleExtensionRateMySuffix[] = [],
        public deductableRates: IRuleDeductableRateMySuffix[] = [],
        public cargoLists?: ICargoGroupMySuffix[],
        public fromCountryLists?: ICountryMySuffix[],
        public toCountryLists?: ICountryMySuffix[],
        public scopeRule?: IScopeMySuffix,
        public loadingType: ILoadingTypeMySuffix[]=[],
        public packingTypes: IPackingTypeMySuffix[] = [],
        public loadingSubTypes: ILoadingSubTypeDto[] = [],
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public lastModifiedByUserRole?: string,
        public toCountryListsId?: number[],
        public fromCountryListsId?: number[],
        public fromEffectiveDate?: string,
        public inceptionDateObj?: {},
        public expiryDateObj?: {},
        public referFormRule?: number,
        public markAsRenew?: boolean,
        public scopeDeductableType?: DeductableType,
        public type?: RuleType,
        public policyMarketType ?:PolicyMarketType,
        public isRuleUsedInCertificate?:boolean,
        public lastModifiedDate?: string,
        public subRuleId?: any[],
        public ruleIdForOts?:number,
        public lineOfBusiness?: string
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
        const deductable = new RuleDeductableRateMySuffix();
        this.deductableRates.push(deductable);
        const extension = new RuleExtensionRateMySuffix();
        this.extensions.push(extension);
        const loadingtype = new LoadingTypeMySuffix()
        this.loadingType.push(loadingtype);
        this.premiumRate = 0;
    }
}
